import * as React from 'react';
import { IconActionChevronRight16, IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './styles.css';
import { ICustomSwiperNavigationRef } from '../../../../components/CustomSwiper';

interface IContainerProps {
  description: string;
  carousel: React.ReactNode;
  navRef: ICustomSwiperNavigationRef;
}

export function ClusterLayout({ carousel, description, navRef }: IContainerProps) {
  return (
    <section className={styles['container']} id="cluster">
      <div className={styles['header']}>
        <div className={styles['description']}>{description}</div>
      </div>
      <div className={styles['carousel']}>
        <button className={`${styles['button']} ${styles['prev']}`} type="button" ref={navRef.prev}>
          <IconActionChevronLeft16 color="icon-secondary-default" />
        </button>
        <button className={`${styles['button']} ${styles['next']}`} type="button" ref={navRef.next}>
          <IconActionChevronRight16 color="icon-secondary-default" />
        </button>
        {carousel}
      </div>
    </section>
  );
}
